export default __webpack_public_path__ + "static/media/activate_filled.fdf9e9c3.svg";